// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBg {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.h300 {\n  height: 300px !important;\n}\n.numTip-value {\n  color: #0082ff;\n}\n", ""]);
// Exports
module.exports = exports;
